import { useState } from "react";

export const useToggle = (initial?: boolean) => {
  const [open, setOpen] = useState<boolean>(!!initial);

  const onToggle = (value?: boolean) => {
    setOpen((prev) => value ?? !prev);
  };

  return [open, onToggle] as const;
};
